export default "__VITE_ASSET__b9b201b0__"